import { render, staticRenderFns } from "./places-to-eat-and-drink-in-goa.vue?vue&type=template&id=09644528&scoped=true"
import script from "./places-to-eat-and-drink-in-goa.vue?vue&type=script&lang=js"
export * from "./places-to-eat-and-drink-in-goa.vue?vue&type=script&lang=js"
import style0 from "./places-to-eat-and-drink-in-goa.vue?vue&type=style&index=0&id=09644528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09644528",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainCategoryCard: require('/workspace/components/MainCategoryCard.vue').default,PopularCategoryCard: require('/workspace/components/PopularCategoryCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
